export default __webpack_public_path__ + "static/media/p03.1dde58e7.jpg";